<template>
  <router-view/>
  <transition name="subscription-modal">
    <div v-if="subscriptionRequiredVisible" class="subscription-modal-backdrop" @click.self="closeSubscriptionModal">
      <div class="subscription-modal">
        <h2>Нужна активная подписка</h2>
        <p>Оформите или продлите подписку, чтобы продолжить работу с карточками.</p>
        <button type="button" class="subscription-modal-primary" @click="goToSubscription">Перейти к подписке</button>
        <button type="button" class="subscription-modal-secondary" @click="closeSubscriptionModal">Закрыть</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      subscriptionRequiredVisible: false
    }
  },
  methods: {
    handleSubscriptionRequired() {
      if (this.$route?.name === 'DashboardSubscription') return
      this.subscriptionRequiredVisible = true
    },
    closeSubscriptionModal() {
      this.subscriptionRequiredVisible = false
    },
    goToSubscription() {
      this.closeSubscriptionModal()
      this.$router.replace({ name: 'DashboardSubscription' })
    }
  },
  mounted() {
    window.addEventListener('subscription-required', this.handleSubscriptionRequired)
  },
  beforeUnmount() {
    window.removeEventListener('subscription-required', this.handleSubscriptionRequired)
  }
}
</script>

<style>
.subscription-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.35);
}

.subscription-modal-enter-active,
.subscription-modal-leave-active {
  transition: opacity 0.22s ease;
}

.subscription-modal-enter-from,
.subscription-modal-leave-to {
  opacity: 0;
}

.subscription-modal-enter-active .subscription-modal,
.subscription-modal-leave-active .subscription-modal {
  transition: transform 0.28s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.22s ease;
}

.subscription-modal-enter-from .subscription-modal,
.subscription-modal-leave-to .subscription-modal {
  opacity: 0;
  transform: translateY(calc(100% + 16px));
}

.subscription-modal {
  width: min(100%, 440px);
  padding: 22px;
  border-radius: 18px;
  background: light-dark(#ffffff, #1c1c1e);
  color: light-dark(#111, #fff);
  box-shadow: 0 20px 80px rgba(0, 0, 0, 0.25);
}

.subscription-modal h2 {
  margin: 0 0 8px;
  font-size: 22px;
}

.subscription-modal p {
  margin: 0 0 18px;
  color: light-dark(#636366, #aeaeb2);
  line-height: 1.4;
}

.subscription-modal-primary,
.subscription-modal-secondary {
  width: 100%;
  min-height: 48px;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
}

.subscription-modal-primary {
  color: #000;
  background: #ace715;
  font-weight: 600;
}

.subscription-modal-secondary {
  color: light-dark(#007aff, #0a84ff);
  background: transparent;
}
</style>
